export default __webpack_public_path__ + "static/AboutUs-RHR-efd573ba941d1a724ca33e9098658722.jpg";